import { Injectable } from '@angular/core';
import { databases, ID, storage } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { EspecialistaOtros } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EspecialistaOtrosService {

  private collectionId = "especialistas_otros";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }

   /**
   * @getData()
   * @returns
   */
   getData(): Promise<EspecialistaOtros[]> {
    return databases.listDocuments<EspecialistaOtros>(
      this.DATABASE_NAME,
      this.collectionId
    ).then(response => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: EspecialistaOtros) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }


  /**
   * @updateDocument()
   * @param idDocument
   * @param data
   * @returns
   */
  updateDocument(idDocument: string, data: EspecialistaOtros) {
    data.$databaseId = ''
    data.$collectionId = ''
    return databases.updateDocument(this.DATABASE_NAME, this.collectionId, idDocument, data);
  }

  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDocuments(idEspecialista: string): Promise<EspecialistaOtros[]> {
    return databases.listDocuments<EspecialistaOtros>(
      this.DATABASE_NAME,
      this.collectionId,
      [
        // Query.select(["$id","idEspecialista","tEspecialidad","idPoblacion"]),
        Query.equal('idEspecialista', idEspecialista),
      ]
    ).then(response => response.documents);
  }

  /**
   * @deleteDocument()
   * @param fileId
   * @returns
   */
  deleteDocument(documentId: string) {
    return databases.deleteDocument(this.DATABASE_NAME, this.collectionId, documentId);
  }
}

